import { TLD } from 'f2tech-shared';

// Mirrors environment.ts (hostname-derived apiUrl) because Vercel runs
// `ng build` without --configuration=production, which means
// angular.json's defaultConfiguration ("development") kicks in and
// fileReplacements swaps environment.ts FOR THIS FILE. Without this
// mirror, production deployments bake in https://f2-admin-service2.f2-tech.com
// and break the .ai rollout. See angular.json defaultConfiguration to
// understand why this file is the one that ships.
export const environment = {
  production: false,
  // apiUrl empty (relative / same-origin) — mirrors environment.ts.
  // See that file's header comment. Mike 2026-07-05.
  get apiUrl(): string {
    return '';
  },
  vendorName: 'F2 Tech LLC',
  contactEmail: 'exchangeagreements@f2-tech.com',
  get selfServiceUrl(): string {
    return `admin.f2-tech.${TLD}/data-agreements`;
  },
};
